<template>
  <div class="main-content">
    <SectionTitle class="animate-target" v-animate-in icon="Q" :title="title"></SectionTitle>
    <QuestionBox :title="questionTitle" :desc="questionDesc" :items="questionItem" v-on:selected="selected" :index="questionAnswer" ></QuestionBox>
    <GoNext class="animate-target" v-animate-in href="/section5/5-3" :selected="selectedValue" required="true"></GoNext>
    <ContentNotice class="animate-target" v-animate-in :txt="noticeTxt" />
  </div>
</template>

<script>

import SectionTitle from "../../components/SectionTitle";
import QuestionBox from "../../components/QuestionBox";
import GoNext from "../../components/GoNext";
import ContentNotice from "../../components/ContentNotice";
import {mapState} from "vuex";

export default {
  name: "s5-2",
  components: {SectionTitle, QuestionBox, GoNext, ContentNotice},
  computed:{
  },
  data(){
    return {
      questionTitle: "Question 2",
      questionDesc: "Persistent albuminuria in T2D and CKD is:<sup>1–4</sup>",
      questionItem:[
          "Associated with CV risk",
          "Associated with progression of CKD",
          "Recognised as a treatment target",
          "All of the above"
      ],
      selectedValue:'',
      questionAnswer:'3',
      noticeTxt:"CKD, chronic kidney disease, CV, cardiovascular; T2D  type 2 diabetes.<br/><div class='brs'></div>"
      +"Reference:<br/><div class='brs'></div>"
      +"1. Inoue K, <i>et al. Ann Epidemiol</i>. 2021;55:15-23. doi:10.1016/j.annepidem.2020.12.004.<br/>"
      +"2. Fox CS, <i>et al. Lancet</i>. 2012;380:166-173. doi:10.1016/S0140-6736(12)61350-6.<br/>"
      +"3. Kidney Health Australia. CKD Management in Primary Care handbook (5th edition). <a target='_blank' class='c-url' href='https://kidney.org.au/health-professionals/ckd-management-handbook'>https://kidney.org.au/health-professionals/ckd-management-handbook</a>.<br/>"
      +"4. RACGP. Management of type 2 diabetes: A handbook for general practice. <a target='_blank' class='c-url' href='https://www.racgp.org.au/getattachment/00186565-b7b3-4eb8-aefb-e7f8ff3973d5/Management-of-type-2-diabetes-A-handbook-for-general-practice.aspx'>https://www.racgp.org.au/getattachment/00186565-b7b3-4eb8-aefb-e7f8ff3973d5/Management-of-type-2-diabetes-A-handbook-for-general-practice.aspx</a>.",
      title:"Post-activity quiz"
    };
  },
  methods:{
    selected:function(value){
      this.selectedValue = value;
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/section5/s5.css";
</style>
